// COMPOONENTS
import { MorseTranslator } from 'components';

// STYLES
import { StyledAppWrapper } from 'Styles';

const App = () => (
	<StyledAppWrapper>
		<MorseTranslator />
	</StyledAppWrapper>
);
export default App;
